export const fallBackErrorMessage =
  "Something went wrong, please try again later!";